import { render } from "./TicketActionDropzone.vue?vue&type=template&id=0f00bf28"
import script from "./TicketActionDropzone.vue?vue&type=script&lang=js"
export * from "./TicketActionDropzone.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__